import React from 'react'
import { Footer, Navbar, Product } from "../components"
 //import { Items } from '../../public/Items.json'


const Products = () => {
  return (
    <>
      <Navbar />
      <Product />
     {/* <Items />*/}
      <Footer />
    </>
  )
}

export default Products